import {
  generatePublicS3ItemPreSignedUrlV1,
  generateS3ItemPreSignedUrlV1,
  type S3Response,
} from "@/lib/data/requests/s3";
import { queryKeys } from "@/lib/data/static";

// Define a subset of ItemType for the specific types used in this file
type S3ItemType =
  | "matter-file"
  | "matter-template"
  | "matter-signature-request-file"
  | "firm-signature-request-file"
  | "message-media"
  | "firm-file"
  | "matter-share-folder-file";

const getPresignedUrl = async (
  itemType: S3ItemType,
  key: string,
  options?: {
    unauthenticated?: boolean;
    shareFolderPasscode?: string;
  },
): Promise<{ data: S3Response }> => {
  const generatePresignedUrl = options?.unauthenticated
    ? generatePublicS3ItemPreSignedUrlV1
    : generateS3ItemPreSignedUrlV1;

  return generatePresignedUrl(itemType)({
    clientMethod: "get_object",
    key,
    shareFolderPasscode: options?.shareFolderPasscode,
  });
};

export const getItemFromPresignedUrlOptions = (
  itemType: S3ItemType,
  key: string,
  options?: {
    unauthenticated?: boolean;
    shareFolderPasscode?: string;
  },
) => {
  return {
    queryKey: [
      queryKeys.matterFileImages,
      key,
      options?.unauthenticated ? "public" : "auth",
      options?.shareFolderPasscode,
    ],
    enabled: !!key,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    queryFn: async () => {
      if (!key) {
        return;
      }
      const presignedURLRes = await getPresignedUrl(itemType, key, options);
      const file = await fetch(presignedURLRes.data.presignedUrl, {
        method: "GET",
      });

      if (!file.ok) {
        throw new Error(
          `Failed to fetch file: ${file.status} ${file.statusText}`,
        );
      }

      return file;
    },
  };
};
